import DeleteController from "csi/table/Delete";
import MessageDialog from "csi/widget/MessageDialog";
import locale from "csi/locale";
import page from "csi/page";
import declare from "dojo/_base/declare";

const WbsDeleteController = declare(DeleteController, {
	/**
		 * @override
		 * Displays a confirmation message instead of an error message if the error is an illegal state errorCode
		 */
	displayError() {
		if (this._errorCode === "SRV_ERR_WBS_WBS_ILLEGAL_STATE") {
			const message = locale.resource("WbsIllegalState");
			const title = locale.resource("RefreshBrowserTitle");
			const buttons = [MessageDialog.BUTTON_REFRESH + MessageDialog.BUTTON_PRIMARY, MessageDialog.BUTTON_CANCEL];
			this.confirmAction({ message, buttons, title });
		} else {
			this.inherited(arguments);
		}
	},
	/**
		 * @override
		 * uses a onConfirm with conditional checks for BUTTON_REFRESH confirmation
		 */
	onConfirm(key) {
		if (key === MessageDialog.BUTTON_DELETE) {
			this.inherited(arguments);
		} else if (key === MessageDialog.BUTTON_REFRESH) {
			page.refreshRootView();
			this.postProcess();
		} else {
			this.postProcess();
		}
	},
});

export = WbsDeleteController;